import React, { useState, useEffect, Suspense } from 'react'
import './price-calendar.scss'
import moment from 'moment'
import leftArrow from '../../assets/images/pagination-left-icon.png'
import rightArrow from '../../assets/images/pagination-right-icon.png'
import dgRestrictedSccs from '../../configs/dgRestrictedSccs';

const DateElement = React.lazy(() => import('./DateElement'))

const PriceCalendar = ({
    calendarDates,
    selectedDate,
    setSelectedDate,
    searchFormData,
    increaseSelectionStartDate,
    calendarStartDate,
    calendarEndDate,
    resultSet
}) => {
    const [isNextBtn, setIsNextBtn] = useState(true)
    const [isPrevBtn, setIsPrevBtn] = useState(true)
    const [visibleDates, setVisibleDates] = useState(5) 
    const [currentIndex, setCurrentIndex] = useState(0); 

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                // Show only the selected date in mobile view
                const selectedIndex = calendarDates.findIndex(
                    (date) => moment(date).isSame(moment(selectedDate), 'day')
                );
                setCurrentIndex(selectedIndex !== -1 ? selectedIndex : 0);
                setVisibleDates(1);
            } else {
                // Show 5 dates for desktop view
                setVisibleDates(5);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [calendarDates, selectedDate]);

    useEffect(() => {
        let isPrevBtn;
        let isNextBtn;
        if (calendarDates && calendarDates.length && calendarEndDate) {
            isPrevBtn = moment(calendarDates[0], 'DD-MMM-YYYY').isAfter(calendarStartDate);
            setIsPrevBtn(isPrevBtn);
            isNextBtn = !moment(calendarDates[calendarDates.length - 1], 'DD-MMM-YYYY')
                .add(1, 'days')
                .isAfter(calendarEndDate);
            setIsNextBtn(isNextBtn);
        }
        if (searchFormData.sccCodes) {
            let result = searchFormData.sccCodes.reduce((acc, item) => {
                acc.push(item.scc);
                return acc;
            }, []);

            if (
                result.includes('AVI') ||
                (searchFormData.shippingItemCode?.product === 'Specialized Commodities' &&
                    !dgRestrictedSccs?.includes(searchFormData.shippingItemCode?.scc)) ||
                searchFormData.dgbookcheck
            ) {
                if (searchFormData.aviBookingDetaills && searchFormData.aviBookingDetaills.length > 0) {
                    let aviBookingMinDate = moment()
                        .add(searchFormData.aviBookingDetaills[0].minBookingDays + 1, 'days')
                        .toDate();
                    let dgBookingMinDate = moment()
                        .add(searchFormData.aviBookingDetaills[1].minBookingDays + 1, 'days')
                        .toDate();
                    if (
                        moment(calendarDates[0], 'DD-MMM-YYYY').isBefore(moment(aviBookingMinDate)) ||
                        (moment(calendarDates[0], 'DD-MMM-YYYY').isBefore(moment(dgBookingMinDate)) &&
                            searchFormData.shippingItemCode !== null)
                    ) {
                        setIsPrevBtn(false);
                    }
                }
            }
        }
    }, [calendarDates, calendarStartDate, calendarEndDate]);

    useEffect(() => {
        if (resultSet) {
            Object.keys(resultSet).forEach((date) => {
                const response = resultSet[date];
                if (!isNextBtn && !isPrevBtn) {
                    return;
                }
                if (
                    response &&
                    !response.isLoading &&
                    response.error &&
                    response.error.description &&
                    response.error.description
                        .toUpperCase()
                        .indexOf('SPOT RATE IS NOT APPLICABLE') !== -1
                ) {
                    if (moment(date, 'DD-MMM-YYYY').isAfter(moment(searchFormData.shippingDate, 'DD-MMM-YYYY'))) {
                        setIsNextBtn(false);
                    } else {
                        setIsPrevBtn(false);
                    }
                }
            });
        }
    }, [resultSet]);

    // Calculate the slice for desktop view to center the selected date
    let start = 0;
    let end = visibleDates;
    if (visibleDates === 5 && calendarDates && calendarDates.length) {
        const selectedIndex = calendarDates.findIndex(
            (date) => moment(date).isSame(moment(selectedDate), 'day')
        );
        start = selectedIndex - 2;
        if (start < 0) start = 0;
        if (calendarDates.length >= 5 && start > calendarDates.length - 5) {
            start = calendarDates.length - 5;
        }
        end = start + 5;
    } else if (visibleDates === 1) {
        start = currentIndex;
        end = currentIndex + 1;
    }

    return (
        <div className='price-calendar'>
            <div className='price-calendar__nav-btn'>
                <button
                    className='prev-btn'
                    onClick={() => {
                        increaseSelectionStartDate(-1);
                    }}
                    disabled={!isPrevBtn}
                >
                    <img src={leftArrow} alt='leftArrow' title='Previous' />
                </button>
            </div>
            <div className='price-calendar__details'>
                {calendarDates && calendarDates.length ? (
                    calendarDates
                        .slice(start, end)
                        .map((date, index) => {
                            // Use the real index in calendarDates for key and customKey
                            const realIndex = start + index;
                            return (
                                <Suspense fallback={<></>} key={realIndex}>
                                    <DateElement
                                        key={realIndex}
                                        customKey={realIndex}
                                        isPrevBtn={isPrevBtn}
                                        isNextBtn={isNextBtn}
                                        calendarLength={calendarDates.length}
                                        date={date}
                                        selectedDate={selectedDate}
                                        setSelectedDate={setSelectedDate}
                                        increaseSelectionStartDate={increaseSelectionStartDate}
                                    />
                                </Suspense>
                            );
                        })
                ) : (
                    <></>
                )}
            </div>
            <div className='price-calendar__nav-btn'>
                <button
                    className='next-btn'
                    onClick={() => {
                        increaseSelectionStartDate(1);
                    }}
                    disabled={!isNextBtn}
                >
                    <img src={rightArrow} alt='rightArrow' title='Next' />
                </button>
            </div>
        </div>
    );
};

export default PriceCalendar;